// extracted by mini-css-extract-plugin
export default {"list":"Socials-module__list--jgw8t","item":"Socials-module__item--s9QdE","icon":"Socials-module__icon--cPc5Z"};